import React from 'react';
import PropTypes from 'prop-types';

/**
 * ThryveLoop v5.2 Logo Component
 * Organic sprout design with sage green and terracotta accents
 * Memoized for performance - only re-renders when props change
 */
const Logo = React.memo(({ size = 32, onClick = null, className = '' }) => {
  const handleClick = onClick ? () => onClick() : null;

  return (
    <svg
      onClick={handleClick}
      style={onClick ? { cursor: 'pointer' } : {}}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Soil/Base */}
      <ellipse cx="32" cy="52" rx="20" ry="8" fill="#5E8C6A" opacity="0.2" />

      {/* Main stem - curves naturally */}
      <path
        d="M 32 52 Q 30 42 28 32 Q 26 22 30 12"
        stroke="#5E8C6A"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />

      {/* Left leaf - larger, organic shape */}
      <g>
        <path
          d="M 28 32 Q 18 28 14 20 Q 16 26 18 32"
          stroke="#5E8C6A"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        <ellipse
          cx="20"
          cy="27"
          rx="4"
          ry="6"
          fill="#5E8C6A"
          opacity="0.3"
          transform="rotate(-30 20 27)"
        />
      </g>

      {/* Right leaf - curved counterpoint */}
      <g>
        <path
          d="M 28 24 Q 38 20 42 14 Q 40 22 36 28"
          stroke="#5E8C6A"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        <ellipse
          cx="40"
          cy="21"
          rx="4"
          ry="6"
          fill="#5E8C6A"
          opacity="0.3"
          transform="rotate(30 40 21)"
        />
      </g>

      {/* Top leaf sprout - tender new growth */}
      <g>
        <path
          d="M 30 12 Q 28 6 30 2"
          stroke="#B85C38"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M 32 12 Q 34 6 32 2"
          stroke="#B85C38"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
      </g>

      {/* Small accent leaves for dynamism */}
      <g opacity="0.6">
        <ellipse
          cx="25"
          cy="40"
          rx="1.5"
          ry="2.5"
          fill="#B85C38"
          transform="rotate(-45 25 40)"
        />
        <ellipse
          cx="40"
          cy="35"
          rx="1.5"
          ry="2.5"
          fill="#B85C38"
          transform="rotate(45 40 35)"
        />
      </g>

      {/* Optional glow/aura effect for focus */}
      <circle
        cx="32"
        cy="32"
        r="28"
        stroke="#5E8C6A"
        strokeWidth="0.5"
        fill="none"
        opacity="0.2"
      />
    </svg>
  );
});

Logo.propTypes = {
  size: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Logo.displayName = 'Logo';

export default Logo;
